import React, { useState, useEffect } from "react"; // Import Pagination styles// Assuming you use react-router for navigation
import { FaCaretUp, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [isHovered, setIsHovered] = useState(false);

const buttonStyles = {
  width: "50px", // Increased size for better visibility
  height: "50px", // Adjusted height to match width
  borderRadius: "50%", // Keep it circular
  backgroundColor: isHovered ? "#FF5733" : "#FFF", // Slightly deeper orange for hover
  border: "2px solid #FF5733", // Matching deeper orange border
  color: isHovered ? "#FFF" : "#FF5733", // Inverted colors on hover
  fontSize: "22px", // Slightly larger font size for better readability
  cursor: "pointer",
  transition: "background-color 0.4s ease, color 0.4s ease, transform 0.2s", // Added transition for smoother color change and hover effect
  outline: "none",
  boxShadow: isHovered
    ? "0 6px 12px rgba(0, 0, 0, 0.3)" // Increased shadow on hover for depth
    : "0 4px 8px rgba(0, 0, 0, 0.2)", // Standard shadow for normal state
  transform: isHovered ? "scale(1.05)" : "scale(1)", // Slight scale effect on hover for feedback

  // Positioning for small screens
  // position: window.innerWidth < 600 ? "absolute" : "static", // Make it absolute for small screens
  // right: window.innerWidth < 600 ? "10px" : "auto", // Align to the right for small screens
  // top: window.innerWidth < 600 ? "10px" : "auto", // Add spacing from the top for small screens
};

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 941);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer className="">
      <div style={{ backgroundColor: "#8C3A00", width: "100%" }}>
        <div
          style={{
            ...styles.flexContainer,
            gap: isSmallScreen ? "20px" : "5%",
          }}
        >
          {/* Useful Links Container */}
          <div
            style={{
              ...styles.flexItem,
              marginTop: "-14px",
              maxWidth: isSmallScreen ? "100%" : "200px",
            }}
          >
            <p style={styles.header}>Useful Links</p>
            <ul style={{ paddingRight: 0 }}>
              <li>
                <a
                  href="/contact-us"
                  style={styles.link}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.linkHover.borderBottom)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.link.borderBottom)
                  }
                >
                  Contact us
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy"
                  style={styles.link}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.linkHover.borderBottom)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.link.borderBottom)
                  }
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/help-support"
                  style={styles.link}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.linkHover.borderBottom)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.borderBottom =
                      styles.link.borderBottom)
                  }
                >
                  Help & Support
                </a>
              </li>
            </ul>
          </div>

          {/* Second Container - Download Our App */}
          <div
            style={{
              ...styles.flexItem,
              paddingLeft: isSmallScreen ? "0px" : "30px",
            }}
          >
            <div style={styles.header}>Download Our App</div>
            <p style={styles.paragraph}>
              Listen to enlightening discourses of HH Swami Paramarthananda
              Saraswathi, anywhere, anytime from the comfort of your
              smartphones.
            </p>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.sastra.im037.sastraprakasika&pcampaignid=web_share"
                target="_blank"
              >
                <img
                  src="https://sastraprakasika.com/wp-content/uploads/2018/07/google-play.png"
                  width="40%"
                  style={{ maxWidth: "200px" }} // Set a max-width to limit the size on XL screens
                />
              </a>
              &emsp;
              <a
                href="https://apps.apple.com/in/app/sastraprakasika/id1480843207"
                target="_blank"
              >
                <img
                  src="https://sastraprakasika.com/wp-content/uploads/2018/07/apple-store.png"
                  width="40%"
                  style={{ maxWidth: "200px" }} // Set a max-width to limit the size on XL screens
                />
              </a>
            </div>
          </div>

          {/* Third Container - Follow Us */}
          <div
            style={{
              ...styles.flexItem,
              paddingLeft: isSmallScreen ? "0px" : "40px",
              maxWidth: isSmallScreen ? "100%" : "270px",
            }}
          >
            <div style={styles.header}>Follow Us</div>
            <p
              style={{
                ...styles.paragraph,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <MdEmail />{" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="mailto:sastraprakasika@gmail.com"
                >
                  sastraprakasika@gmail.com
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <FaPhoneAlt /> +91-44-28475009
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <FaPhoneAlt /> +91-44-28470311
              </div>
              <br />
              <a
                href="https://www.facebook.com/sastra.prakhasika.3"
                rel="noopener"
              >
                <img src="https://sastraprakasika.com/wp-content/themes/remix-child/img/facebook.png"></img>
              </a>
            </p>
          </div>
        </div>
      </div>
      <div style={footerStyles}>
        <div style={contentStyles}>
          <span
            style={{ textAlign: window.innerWidth < 600 ? "center" : "left" }}
          >
            Copyright &copy; 2024 Sastraprakasika Trust. All Rights Reserved.
          </span>
          <span
            style={{ textAlign: window.innerWidth < 600 ? "center" : "right" }}
          >
            Designed by{" "}
            <a
              href="https://www.imaginetventures.com"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyles}
            >
              ImagiNET Ventures
            </a>
          </span>
        </div>
        &emsp;
          <button
            style={buttonStyles}
            onClick={scrollToTop}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <FaCaretUp size={20} />
          </button>
      </div>
    </footer>
  );
};

// Inline styles for the component
const styles = {
  flexContainer: {
    backgroundColor: "#8C3A00",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    // alignItems: "flex-start", // Align items to the start (top) of the container
    flexWrap: "wrap", // Allows items to wrap on smaller screens
    margin: "0 auto", // Center the flex container
    width: "70%", // Ensures the container takes up full width
    // maxWidth: "1600px", // Max width for larger screens
  },
  flexItem: {
    flex: "1 1 300px", // Grow, shrink, and initial width
    borderRadius: "8px",
    paddingTop: "20px",
    width: "100%", // Maximum width for items
    // minWidth: "300px", // Minimum width before wrapping occurs
    boxSizing: "border-box", // Includes padding and border in the element's total width and height
  },
  header: {
    fontSize: "20px",
    // fontWeight: 'bold',
    marginBottom: "0px",
    borderBottom: "3px solid #fff", // Underline style using border-bottom
    display: "inline-block", // To fit the underline to the text width
  },
  paragraph: {
    marginBottom: "10px",
    fontSize: "16px",
    lineHeight: "1.5",
  },
  list: {
    // listStyleType: "disc",
    paddingLeft: "20px",
  },
  link: {
    padding: "10px",
    // width: "100%",
    color: "#ffffff",
    textDecoration: "none",
    // borderBottom: "1px solid #ddd", // Light underline for all links
    paddingBottom: "5px",
    // display: "inline-block",
    // transition: "border-color 0.3s",
  },
  linkHover: {
    // borderBottom: "2px solid #fff", // Solid underline on hover
  },
};

const footerStyles = {
  color: "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#8C3A00",
  width: "100%",
  padding: "20px",
  boxSizing: "border-box",
  flexDirection: "row", // Default direction for larger screens
};

const contentStyles = {
  display: "flex",
  flexDirection: window.innerWidth < 800 ? "column" : "row", // Switch to column for smaller screens
  justifyContent: "space-between",
  alignItems: "center",
  textAlign: "center",
  width: "100%",
};

const mobileStyles = {
  "@media (max-width: 600px)": {
    flexDirection: "column",
    alignItems: "flex-start",
  },
};

const linkStyles = {
  color: "orange",
  textDecoration: "none",
  fontWeight: 700,
  fontSize: "16px", // Similar size to the icons
};

// const responsiveFooterStyles = {
//   display: "flex",
//   flexDirection: window.innerWidth <= 600 ? "column" : "row", // Stack on small screens
//   alignItems: "center",
// };
export default Footer;
